import { useState } from 'react';
import AnimateHeight from 'react-animate-height';

import { useSettings } from '../context/SettingsProvider';
import { useComments } from '../context/CommentsProvider';

export default function CollapsableWrapper({ children }) {
	const settings = useSettings();
	const commentsContext = useComments();
	const isCollapsable =
		typeof settings.isCommentsCollapsable !== 'undefined'
			? settings.isCommentsCollapsable
			: false;
	const [height, setHeight] = useState(
		typeof settings.defaultCommentsCollapseState !== 'undefined' &&
			!settings.defaultCommentsCollapseState
			? 'auto'
			: 0
	);
	// const [status, setStatus] = useState(typeof settings.defaultCommentsCollapseState !== "undefined" ? settings.defaultCommentsCollapseState : false);

	if (!isCollapsable) return children;

	return (
		<div className="amsive-comments--collapsable">
			{(settings.isCommentsOpen || !!commentsContext.count) && (
				<>
					<button
						className="amsive-comments--collapsable--btn comments--btn"
						aria-expanded={height !== 0}
						aria-controls="amsive-comments--collapsable-panel"
						onClick={() => setHeight(height === 0 ? 'auto' : 0)}
					>
						{height === 0 ? 'Show Comments' : 'Hide Comments'}
					</button>

					<AnimateHeight
						id="amsive-comments--collapsable-panel"
						duration={500}
						height={height}
					>
						{children}
					</AnimateHeight>
				</>
			)}
		</div>
	);
}
